module.exports = __webpack_public_path__ + "img/ico_business_2.02d60c94.svg";